import {createSvgIcon} from '../create-svg-icon';

export const HPlusMobiledataIcon = createSvgIcon(
  <path d="M12 11H6V7H4v10h2v-4h6v4h2V7h-2v4zm10 0h-2V9h-2v2h-2v2h2v2h2v-2h2v-2z" />
, 'HPlusMobiledataOutlined');
